export default __webpack_public_path__ + "static/media/bug.dd276cf2.webp";